'use strict';

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    if (!$('.tracking-consent').data('caonline')) {
        return;
    }

    var urlContent = $('.tracking-consent').data('url');
    var urlAccept = $('.tracking-consent').data('accept');

    var htmlString = '<!-- Modal -->'
        + '<div class="consent-tracking-modal" id="consent-tracking" role="dialog">'
        + '<div class="modal-body"></div>'
        + '<button class="affirm tracking-modal-affirm" data-url="' + urlAccept + '">'
        + 'OK'
        + '</button>'
        + '</div>';
    $('body').append(htmlString);

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('#consent-tracking').find('.modal-body').html(response);
            // Trigger custom event to notify about banner display
            $(document).trigger('cookiesBannerShown');
        },
        error: function () {
            $('#consent-tracking').remove();
            // Trigger custom event to notify about banner removal
            $(document).trigger('cookiesBannerHidden');
        }
    });

    $('#consent-tracking button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $('#consent-tracking').remove();
                // Trigger custom event to notify about banner removal
                $(document).trigger('cookiesBannerHidden');
            },
            error: function () {
                $('#consent-tracking').remove();
                // Trigger custom event to notify about banner removal
                $(document).trigger('cookiesBannerHidden');
            }
        });
    });
}

module.exports = function () {
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }
};
